module.exports = __webpack_public_path__ + "static/media/deletewhite.2019c2ef.svg";